<template>
    <header class="section page-header">
        <!-- RD Navbar-->
        <div class="rd-navbar-wrap rd-navbar-shop-header">
            <nav class="rd-navbar" data-layout="rd-navbar-fixed" data-sm-layout="rd-navbar-fixed" data-md-layout="rd-navbar-fixed" data-md-device-layout="rd-navbar-fixed" data-lg-layout="rd-navbar-fixed" data-xl-layout="rd-navbar-static" data-lg-device-layout="rd-navbar-fixed" data-xl-device-layout="rd-navbar-static" data-md-stick-up-offset="100px" data-lg-stick-up-offset="150px" data-stick-up="true" data-sm-stick-up="true" data-md-stick-up="true" data-lg-stick-up="true" data-xl-stick-up="true">
                <div class="rd-navbar-top-panel novi-background">
                    <div class="rd-navbar-nav-wrap navbar-wrap-leftside">
                        <!-- RD Navbar Nav-->
                        <ul class="rd-navbar-nav navbar-leftside">
                            <li><a @click.prevent="redirect('https://eowpf.alc.co.jp', 'header_logo_click')" class="header-logo-link" href="#" target="_self"><img class="logo-defaults" src="/images/eowp/eowp-pro3.png" alt="英辞郎 on the WEB Pro" /></a></li>
                        </ul>
                    </div>
                </div>
                <div class="rd-navbar-top-panel novi-background main-header">
                    <div id="navbar-burger" class="rd-navbar-nav-wrap">
                        <!-- RD Navbar Nav-->
                        <ul class="rd-navbar-nav navbar-rightside" @click="closeMenu()">
                            <li v-show="!this.session"><a href="#" @click="trackHeaderHyperlink(pageLinks.alcEowpSignupLink, 'header_register_click')">アカウント新規登録</a></li>
                            <li v-show="!this.session && !this.signInPage"><a href="/signin">ログイン</a></li>
                            <li v-show="this.user" class="user-email-mobile"><a href="#">{{this.user}}</a></li>
                            <li v-show="isLoginAsActive() && this.user"><router-link class="switchback" to="/switchback">Switch Back</router-link></li>
                            <li v-show="this.session"><router-link to="/account">アカウントページ</router-link></li>
                            <li v-show="this.user" class="user-email-desktop"><a href="#" @click="redirect('', 'header_email_click')">{{this.user}} </a></li>
                            <li v-show="this.session"><a href="#" @click="redirect('/signout', 'head_signout_click')">ログアウト</a></li>
                        </ul>
                    </div>
                </div>
                <div class="rd-navbar-inner burger-navbar">
                    <!-- RD Navbar Panel-->
                    <div class="rd-navbar-panel">
                        <!-- RD Navbar Toggle-->
                        <button class="rd-navbar-toggle" data-rd-navbar-toggle=".rd-navbar-nav-wrap"><span></span></button>
                        <!-- RD Navbar Brand-->
                        <div class="rd-navbar-brand"><a class="brand-name" href="#" @click.prevent="redirect('https://eowpf.alc.co.jp', 'header_logo_click')"><img class="logo-default" src="/images/eowp/eowp-pro3.png" alt="" width="139" height="43"/><img class="logo-inverse" src="/images/eowp/eowp-pro3.png" alt="" width="127" height="38"/></a></div>
                    </div>
                    <div class="rd-navbar-aside-right">
                        <div v-show="!this.session" class="rd-navbar-shop rd-navbar-login login-button"><a class="rd-navbar-shop-icon mdi mdi-login" href="#" @click="redirect('/signin', 'head_mobile_signin_click')"><span class="d-none d-xl-inline">Login</span></a></div>
                        <div v-show="this.session" class="rd-navbar-shop rd-navbar-login login-button"><a class="rd-navbar-shop-icon mdi mdi-logout" href="#" @click="redirect('/signout', 'head_mobile_signout_click')"><span class="d-none d-xl-inline">Logout</span></a></div>
                    </div>
                </div>
            </nav>
        </div>
      </header>
</template>

<style scoped>
.main-header a.switchback{
    color: red !important;
}
header nav{
    background-color: #efefef!important;
}
a.header-logo-link{
    padding-top: 7px!important;
    padding-bottom: 0px!important;
}
.page-header .rd-navbar-nav-wrap .rd-navbar-nav a img{
    width: 300px!important;
}
.main-header{
    background-color: #f8f9fa!important;
}
.main-header a{
    color: #333333!important;
}
.user-email-mobile{
    display: none!important;
    font-size: 11px;
}
.navbar-wrap-leftside{
    float:left;
}
.navbar-leftside{
    text-align: start;
}
.navbar-rightside{
    text-align: right;
    overflow: auto;
}
.rd-navbar-nav-wrap{
    padding-top: 8px;
    padding-bottom: 8px;
}
.company-logo{
    font-size: 32px!important;
    position: relative;
    display: flex;
}
.signin{
    position: relative;
    display: inline-flex;
    float: right !important;
    padding-top: 17px;
    margin-right: 10px;
}
.login-button{
    float: right;
}
li.user-email-desktop a{
    text-transform: none!important;
}
li.user-email-mobile a{
    text-transform: none!important;
}
li.user-email-mobile a:first-letter{
    text-transform: none!important;
}
@media screen and (max-width: 1199px) {
    div.burger-navbar {
        display: inline !important;
    }
    li.user-email-desktop{
        display: none!important;
    }
    li.user-email-mobile{
        display: block!important;
    }
    .navbar-rightside{
        text-align: left!important;
    }
}
@media screen and (min-width: 1200px) {
    div.burger-navbar {
        display: none !important;
    }
}
</style>

<script>
import DomainSpecific from "../../js/helpers/DomainSpecific";
import { mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            pageLinks: {
                alcEowpSignupLink: ''
            }
        };
    },
    computed: {
        ...mapGetters({
            session: 'user/session',
            user: 'user/user',
            authorized_user: 'user/authorized_user',
        }),
        signInPage: () => {
            let path = window.location.pathname + "";
            return path.indexOf("/sign") >= 0;
        }
    },
    created() {
        let domainSpecific = new DomainSpecific();
        this.pageLinks.alcEowpSignupLink = domainSpecific.value(DomainSpecific.ALC_EOWP_SIGNUP);
    },
    methods: {
        ...mapActions({
            trackClickEvent: 'ga/trackClickEvent',
            trackOutboundClickEvent: 'ga/trackOutboundClickEvent'
        }),
        closeMenu(){
            setTimeout(() => {
                window.jQuery("div.rd-navbar-top-panel > div#navbar-burger").removeClass("active");
                window.jQuery("div.rd-navbar-top-panel > div.navbar-wrap-leftside").removeClass("active");
            }, 100);
        },
        isLoginAsActive(){
            return (this.authorized_user && this.authorized_user.user && this.authorized_user.session);
        },
        redirect(url, eventName){ 
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title, url: url});
        },
        trackHeaderHyperlink(url, eventName){
            this.trackOutboundClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title, url: url});
        }
    }
}
</script>
